/*eslint-disable*/
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { createPopper } from "@popperjs/core";
import Swal from "sweetalert2";
import BASE_URL from "components/BaseUrl/apiConfig";
// components

import PagesDropdown from "components/Dropdowns/PagesDropdown.js";
import ExpenseDropdown from "components/Dropdowns/ExpenseDropdown";
import QuantityTrackingDropdown from "components/Dropdowns/QuantityTrackingDropdown";
import DocumentDropdown from "components/Dropdowns/DocumentDropdown";

export default function Navbar(props) {
  const history = useHistory();
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };
  //Check localstorage null or not
  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  const sendReportEmail = async () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const groupId = userData.groupId;
    try {
      // Fetch the email addresses associated with the groupId
      const emailResponse = await fetch(
        `${BASE_URL}/api/Expense/GetEmailAddresses?groupId=${groupId}`
      );
      const emailData = await emailResponse.json();

      // Send the report to the fetched email addresses
      const encodedEmails = encodeURIComponent(emailData.msg);
      const reportResponse = await fetch(
        `${BASE_URL}/api/Expense/GetMessagesReport?groupId=${groupId}&emails=${encodedEmails}`,
        {
          method: "GET", // No body needed for GET
        }
      );

      if (reportResponse.ok) {
        Swal.fire({
          title: "Success!",
          text: "Messages report has been sent successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to send messages report.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error sending report:", error);
      Swal.fire({
        title: "Error!",
        text: "An error occurred while sending the report.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // Retrieve user data from local storage
  const storedUserData = localStorage.getItem("userData");
  let userName = "";
  let userTypeId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);

    userName = userData.userName;
    userTypeId = userData.userTypeId;
  }

  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <>
      <nav
        className="navbar navbar-expand-lg bg-white navbar-light sticky-top py-lg-0 px-lg-5 mb-3  shadow"
        data-wow-delay="0.1s"
      >
        {/* <div className="container px-4 mx-auto flex flex-wrap items-center justify-between"> */}
        {/* Logo Section */}
        {/* <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start"> */}
        <Link to="/dashboard" className="navbar-brand ms-4">
          <img
            src={require("assets/img/essentials_small.png")}
            alt="Logo not found"
            style={{ width: "200px" }}
          />
        </Link>
        {/* Navbar Toggle Button */}
        <button
          className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
          type="button"
          onClick={() => setNavbarOpen(!navbarOpen)}
        >
          <i className="fas fa-bars"></i>
        </button>
        {/* </div> */}

        {/* Navbar Links */}
        <div
          className={
            "lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none" +
            (navbarOpen ? " block rounded shadow-lg" : " hidden")
          }
          id="example-navbar-warning"
        >
          <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
            <li className="flex items-center">
              <Link
                to="/dashboard"
                className=" custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-3 py-3 lg:py-2 flex items-center text-l font-bold"
              >
                <i className="lg:text-blueGray-200 text-blueGray-200 text-3xl text-lg leading-lg" />
                Dashboard
              </Link>
            </li>
          
            <li className="flex items-center ">
              {/* <ExpenseDropdown /> */}
              <DocumentDropdown />
            </li>
            <li className="flex items-center">
              <ExpenseDropdown />
              {/* <QuantityTrackingDropdown /> */}
            </li>
            <li className="flex items-center">
              <Link
                to="/notes"
                className=" custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-3 py-3 lg:py-2 flex items-center text-l font-bold"
              >
                <i className="lg:text-blueGray-200 text-blueGray-200 text-3xl text-lg leading-lg" />
                Notes
              </Link>
            </li>
            <li className="flex items-center">
              <QuantityTrackingDropdown />
            </li>
            <li className="flex items-center">
              <div
                className=" custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-3 py-3 lg:py-2 flex items-center text-l font-bold"
                // href="#"
                to="/marketingDashboard"
                ref={btnDropdownRef}
                onMouseOver={(e) => {
                  e.preventDefault();
                  openDropdownPopover();
                }}
                onMouseLeave={(e) => {
                  e.preventDefault();
                  closeDropdownPopover();
                }}
              >
                Marketing
                <i
                  className="fa fa-angle-down"
                  aria-hidden="true"
                  style={{ margin: "5px" }}
                ></i>
                <div
                  ref={popoverDropdownRef}
                  className={
                    (dropdownPopoverShow ? "block " : "hidden ") +
                    "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
                  }
                >
                  <span
                    className={
                      "text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-blueGray-400"
                    }
                  ></span>
                  <Link
                    to="/marketingDashboard"
                    className={
                      "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                    }
                  >
                    Dashboard
                  </Link>
                  <Link
                    to="/emailChecker"
                    className={
                      "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                    }
                  >
                    Email Verifier
                  </Link>

                  <Link
                    to="/messageLogs"
                    className="custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                  >
                    Messages
                  </Link>
                  <Link
                    to="/emailServerSettings"
                    className="custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                  >
                    Email Sender Settings
                  </Link>
                  {/* {userTypeId != 3 ? (
                <Link
                  to="/sendEmailReport"
                  // onClick={sendReportEmail}
                  className="custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                >
                  Send Messages Report
                </Link>
                ) : null} */}
                </div>
              </div>
            </li>
            {userTypeId != 3 ? (
              <li className="flex items-center">
                <Link
                  to="/getAllSubUsers"
                  className=" custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-3 py-3 lg:py-2 flex items-center text-l font-bold"
                >
                  <i className="lg:text-blueGray-200 text-blueGray-200 text-3xl text-lg leading-lg" />
                  Users
                </Link>
              </li>
            ) : null}

            <li className="flex items-center">
              <PagesDropdown />
            </li>
          </ul>
        </div>
        {/* </div> */}
      </nav>
    </>
  );
}
